"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var serialOperation_1 = require("spry-react/SerialOperation/serialOperation");
var es6_promise_1 = require("es6-promise");
// Each fetch operation here will only run one at a time.  If another operation is called while one is already pending it
// will NOT start, it will just be ignored, and a promise that never resolves or rejects will be returned.
// UNLESS a concurrencyContext is specified, then the operation will be started regardless of if another operation is already
// pending.
var FetchWithSerialOperationHandling = /** @class */ (function () {
    function FetchWithSerialOperationHandling(startSerialOperation, fetcher) {
        this.startSerialOperation = startSerialOperation;
        this.fetcher = fetcher;
    }
    FetchWithSerialOperationHandling.prototype.getJson = function (url, concurrencyContext, feedbackType) {
        var _this = this;
        if (concurrencyContext)
            return this.fetcher.getJson(url, concurrencyContext);
        var promise = this.startSerialOperation(function () { return _this.fetcher.getJson(url); }, (feedbackType !== null && feedbackType !== void 0 ? feedbackType : serialOperation_1.FeedbackType.LoadingBanner));
        return this.returnPromise(promise);
    };
    FetchWithSerialOperationHandling.prototype.getJsonWithData = function (url, data, concurrencyContext, feedbackType) {
        var _this = this;
        if (concurrencyContext)
            return this.fetcher.getJsonWithData(url, data, concurrencyContext);
        var promise = this.startSerialOperation(function () { return _this.fetcher.getJsonWithData(url, data); }, (feedbackType !== null && feedbackType !== void 0 ? feedbackType : serialOperation_1.FeedbackType.LoadingBanner));
        return this.returnPromise(promise);
    };
    FetchWithSerialOperationHandling.prototype.postJson = function (url, data, concurrencyContext, feedbackType) {
        var _this = this;
        if (concurrencyContext)
            return this.fetcher.postJson(url, data, concurrencyContext);
        var promise = this.startSerialOperation(function () { return _this.fetcher.postJson(url, data); }, (feedbackType !== null && feedbackType !== void 0 ? feedbackType : serialOperation_1.FeedbackType.FullPageSpinner));
        return this.returnPromise(promise);
    };
    FetchWithSerialOperationHandling.prototype.postFormData = function (url, data, feedbackType) {
        var _this = this;
        var promise = this.startSerialOperation(function () { return _this.fetcher.postFormData(url, data); }, (feedbackType !== null && feedbackType !== void 0 ? feedbackType : serialOperation_1.FeedbackType.FullPageSpinner));
        return this.returnPromise(promise);
    };
    FetchWithSerialOperationHandling.prototype.returnPromise = function (promise) {
        if (promise !== null)
            return promise;
        else {
            /* note: this request was "cancelled" so we return a new promise for the result that we never resolve */
            return new es6_promise_1.Promise(function (resolve) { });
        }
    };
    return FetchWithSerialOperationHandling;
}());
exports.FetchWithSerialOperationHandling = FetchWithSerialOperationHandling;
